import { SidebarState as SState } from './reducer';
import { SidebarType as SType } from './types';

export * from './actions';
export {
  default as reducer,
  isCodeReviewSidebarOpen,
  isBranchSidebarOpen,
  isCommitSidebarOpen,
  isCreatePRSidebarOpen,
  isSidebarOpen,
  isSourceSidebarOpen,
  getCodeReviewSidebarWidth,
  getSourceSidebarWidth,
  getBranchSidebarWidth,
  getCommitSidebarWidth,
  getCreatePRSidebarWidth,
  getSidebarWidth,
  getCodeReviewSidebarTabIndex,
  getBranchSidebarTabIndex,
  getCommitSidebarTabIndex,
  getCreatePRSidebarTabIndex,
} from './reducer';
export type SidebarState = SState; // TODO: P2X-920 Remove explicitly stated type

export { default as toggleSidebarSaga } from './sagas/toggle-sidebar-saga';
export { default as updateSidebarStateSaga } from './sagas/update-sidebar-state-saga';
export type SidebarType = SType; // TODO: P2X-920 Remove explicitly stated type
